// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Donation_wrapper__2-R1O","block":"Donation_block__2dyJC"};